import React from "react";

import { _t } from "../../../languageHandler";
import BaseDialog from "./BaseDialog";
import DialogButtons from "../elements/DialogButtons";
import { APP_NAME } from "../../../dth/constants";

interface IProps {
    onFinished(): void;
}

export default class IntegrationsImpossibleDialog extends React.Component<IProps> {
    private onAcknowledgeClick = (): void => {
        this.props.onFinished();
    };

    public render(): React.ReactNode {
        const brand = APP_NAME;

        return (
            <BaseDialog
                className="mx_IntegrationsImpossibleDialog"
                hasCancel={false}
                onFinished={this.props.onFinished}
                title={_t("integrations.impossible_dialog_title")}
            >
                <div className="mx_IntegrationsImpossibleDialog_content">
                    <p>{_t("integrations.impossible_dialog_description", { brand })}</p>
                </div>
                <DialogButtons
                    primaryButton={_t("action.ok")}
                    onPrimaryButtonClick={this.onAcknowledgeClick}
                    hasCancel={false}
                />
            </BaseDialog>
        );
    }
}
